import Switch from '@/common/atoms/Switch'
import React from 'react'

interface Props {
  label: string
  isChecked: boolean
  onChange(checked: boolean): void
}

// One notification line: a label and its switch.
//
// The caller passes the RESOLVED state, never the raw preference — an email
// nobody ever configured must show what it actually does today (EM-D3).
export default function NotificationSwitch({
  label,
  isChecked,
  onChange,
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.checked)

  return (
    <Switch isChecked={isChecked} onChange={handleChange}>
      {label}
    </Switch>
  )
}
